<template lang="pug">
	.passo_a_passo__aplicacao__item
		p('v-html'="label")
</template>

<script>
export default {
	name: "AplicacaoItem",
	props: [ "label"]
}
</script>
